import { ACTIVE_CONTRACTS } from "./app.config";

// Two sell-side markets share one swap UI. Each defines which on-chain
// methods to call (the two DEXes differ slightly in method names).
export const MARKETS = [
  {
    key: "scn",
    label: "SCN",
    name: "SmartCore Node Fraction",
    token: ACTIVE_CONTRACTS.scnToken,
    dex: ACTIVE_CONTRACTS.scnDex,
    decimals: 18,
    priceDecimals: 2,
    theme: "scn",
    quoteMethod: "quote",        // SCNDex.quote(amount)
    priceMethod: "currentPrice", // SCNDex.currentPrice()
  },
  {
    key: "core",
    label: "CORE",
    name: "Core Token",
    token: ACTIVE_CONTRACTS.coreToken,
    dex: ACTIVE_CONTRACTS.coreDex,
    decimals: 18,
    priceDecimals: 3,
    theme: "core",
    quoteMethod: "quoteSell",    // CoreDex.quoteSell(amount)
    priceMethod: "getPrice",     // CoreDex.getPrice()
  },
];

export const getMarket = (key) => MARKETS.find((m) => m.key === key) || MARKETS[0];
